module.exports = __webpack_public_path__ + "img/bgR6.8c04c103.png";